import React from 'react';
import { getParentClasses } from '../utils/get-parent-classes.js';
import { CardParentBox } from '../../CardComponents/card-parent-box/component.js'; // To keep things DRY, splitting this off to a component

var LegacyParentBox = function LegacyParentBox(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var parentLabel = cardProps.parentLabel,
      parentIcon = cardProps.parentIcon,
      parentChevron = cardProps.parentChevron,
      _cardProps$type = cardProps.type,
      type = _cardProps$type === void 0 ? 'wide' : _cardProps$type,
      mediaSize = cardProps.mediaSize,
      _cardProps$mediaPosit = cardProps.mediaPosition,
      mediaPosition = _cardProps$mediaPosit === void 0 ? 'left' : _cardProps$mediaPosit;

  if (!parentLabel) {
    return null;
  }

  var toggleChildren = cardEffects.toggleChildren,
      showChildren = cardEffects.showChildren,
      width = cardEffects.width,
      cardWidth = cardEffects.cardWidth;
  return /*#__PURE__*/React.createElement(CardParentBox, {
    chakra: 'off',
    label: parentLabel,
    icon: parentIcon,
    chevron: parentChevron,
    className: getParentClasses({
      width: width,
      type: type,
      mediaSize: mediaSize,
      mediaPosition: mediaPosition,
      cardWidth: cardWidth
    }),
    toggleChildren: toggleChildren,
    showChildren: showChildren
  });
};

LegacyParentBox.displayName = "LegacyParentBox";
export { LegacyParentBox };